import { createFileRoute } from '@tanstack/react-router'

import { PolicyRoute } from '@/pages/legal/route-entries/privacy-policy'
import { buildPageTitle } from '@/utils/seo'

export const Route = createFileRoute('/_layout/privacy-policy')({
  component: PolicyRoute,
  head: () => {
    return {
      meta: [
        {
          title: buildPageTitle('Privacy Policy'),
        },
      ],
    }
  },
})
